import React from "react";
import get from "lodash/get";
import { useQuery, useMutation } from "services/Client";
import { useNavigate, useParams } from "react-router-dom";
import withNotification from "services/Notification";

import List from "./View";

function All({ notification }) {
  const { id: courseId } = useParams();

  const { data } = useQuery({
    event: "level.get.many",
    variables: {
      where: { courseId: { _eq: courseId } },
    },
  });

  const dataList = get(data, "level", [])
    .slice(0)
    .sort((a, b) => a.order - b.order);

  const { mutate: deleteTest } = useMutation({
    event: "level.delete",
  });
  let navigate = useNavigate();

  const removeTest = async (mutate, id) => {
    mutate({ variables: { where: { id } } })
      .then((res) => {
        if (get(res, "data.deletelevel.id")) {
          notification.success("Delete Successful");
        } else {
          notification.error("Error");
        }
      })
      .catch((e) => {});
  };
  return (
    <List
      data={dataList}
      handleCreate={() => navigate("new")}
      handleDelete={(id) => removeTest(deleteTest, id)}
    />
  );
}

export default withNotification(All);
